// THIS FILE IS AUTO GENERATED! Local values are for development only.
export const version = {
  hash: 'd7cb9d0d3263d2dee3a76da46cfa6b4b881e0822',
  hashShort: 'd7cb9d0'
};
